<div class="file-preview">
    <div class="file-preview__wrapper">
        <div class="file-preview__wrapper--inner">
            <!-- when loading -->
            <div [hidden]="!isLoading">
                <div class="file-preview__container">
                    <div class="file-preview__content">
                        <lib-progress #filePreviewProgressBar 
                            [id]="'file-preview-progress-bar'"
                            [loader]="true"
                            [spinner]="false"
                            [spinnerPosition]="'center'">
                        </lib-progress>
                    </div>
                </div>
            </div>
            <div *ngIf="!isLoading">
                <div>
                    <div *ngIf="requestedFile && requestedFile?.Size > PREVIEW_BYTE_MAX_LIMIT">
                        <lib-error-alert-message [alertMsg]="FILE_TOO_LARGE_ALERT">
                        </lib-error-alert-message>
                    </div>

                    <div *ngIf="requestedFile">
                        <div *ngIf="requestedFile?.Size <= PREVIEW_BYTE_MAX_LIMIT && !errorMessage">

                            <div [ngSwitch]="fileType?.toString()">

                                <div *ngSwitchCase="ALL_SUPPORTED_FILE_TYPES.TEXT_FILE.toString()">
                                    <div class="file-preview__container">
                                        <div class="file-preview__content">
                                            <div class="file-preview__content--scrollable">
                                                <pre>{{ hrefContent }}</pre>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div *ngSwitchCase="ALL_SUPPORTED_FILE_TYPES.PDF_FILE.toString()">
                                    <div class="file-preview__container file-preview__container--pdf">
                                        <div class="file-preview__content file-preview__content--pdf">
                                            <div class="file-preview__content--pdf--scrollable">
                                                <iframe 
                                                    [attr.src]="hrefUrl | safeUrl" 
                                                    type="application/pdf"
                                                    width="100%"
                                                    height="100%"
                                                    #filePreviewPdfObject>
                                                    <p class="alert alert-info">
                                                        You don't seem to have a PDF reader installed.
                                                        <a href="http://get.adobe.com/reader/">Get Adobe Reader</a>
                                                    </p>
                                                </iframe>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div *ngSwitchCase="ALL_SUPPORTED_FILE_TYPES.IMAGE_FILE.toString()"
                                    class="bs-modal-file-preview-img">
                                    <div class="file-preview__container">
                                        <div class="file-preview__content--img">
                                            <div class="file-preview__content--img--scrollable">
                                                <a href="{{ hrefUrl }}" target="_blank">
                                                    <img src="{{ hrefUrl }}" class="file-preview__img" />
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div *ngSwitchDefault>
                                    <div *ngIf="!errorMessage">
                                        <lib-error-alert-message alertMsg="BaseSpace Sequence Hub doesn't support previewing this type of file
                                        (.{{ requestedFile.extension }}).
                                        Download the file instead to view its contents.">
                                        </lib-error-alert-message>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>


                    <div *ngIf="errorMessage" >
                        <lib-error-alert-message [errorMsg]="errorMessage">
                        </lib-error-alert-message>
                    </div>
                </div>
            </div>

        </div>
    </div>
</div>